import { useState, useContext } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { deleteData, fetchData } from '../../service/dataServices';
import { Button, Col, Divider, Popconfirm, Row, Space, Table } from 'antd';
import { DeleteOutlined, PlusOutlined, QuestionCircleOutlined, EditOutlined } from '@ant-design/icons';
import CustomContent from '../../../components/Content/CustomContent';
import moment from 'moment-hijri';
import UserContext from '../../../pages/layout/UserContext';
import checkPermission from '../../../components/Authorization/Util';
import ForbiddenResult from '../../../components/Authorization/ForbiddenResult';

const ShowForms = () => {

  const { t, i18n } = useTranslation();
  const history = useHistory();
  const currentUser = useContext(UserContext);

  const hasReadPerm = checkPermission(currentUser, 'formSchema', 'read');
  const hasWritePerm = checkPermission(currentUser, 'formSchema', 'write');

  const [selectedItem, setSelectedItem] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [data, setData] = useState([]);

  const response = fetchData('/api/form-schema', data => setData(data));
  const deleteMutation = deleteData('/api/form-schema');

  const handleSingleDelete = () => {
    deleteMutation.mutate({ idList: selectedItem.id });
  };

  const onDelete = () => {
    deleteMutation.mutate({ idList: selectedRowKeys.join(',') });
    setSelectedRowKeys([]);
  };

  const onAdd = () => {
    history.push('/add-new-form');
  };

  const onEdit = (record) => {
    history.push(`/edit-form/${record.id}`);
  };

  const columns = [
    {
      title: t('forms.formName'),
      dataIndex: 'name',
      key: 'name',
      render: (val) => val?.[i18n.language] || val?.['en']
    },
    {
      title: t('forms.user'),
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: t('forms.createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => {
        return text ? moment.utc(text).local().format('MMMM Do YYYY, h:mm:ss a') : text;
      },
    },
    {
      title: t('forms.action'),
      key: 'action',
      render: (_, record) => (
        <Space direction="horizontal" size="middle">
          {hasWritePerm && (
            <Button
              type="link"
              icon={<EditOutlined />}
              onClick={(e) => {
                e.stopPropagation();
                onEdit(record);
              }}
            >
              {t('common.edit')}
            </Button>
          )}
          {hasWritePerm && (
            <Popconfirm
              title={t('common.confirmation')}
              description={t('common.areYouSureToDelete')}
              placement="left"
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={handleSingleDelete}
              okButtonProps={{ size: 'middle' }}
              okText={t('common.yes')}
              cancelButtonProps={{ size: 'middle' }}
              styles={{ body: { padding: 16 } }}
            >
              <Button
                type="link"
                danger
                icon={<DeleteOutlined />}
                onClick={(e) => e.stopPropagation()}
              >
                {t('common.delete')}
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  if (!hasReadPerm) {
    return <ForbiddenResult />;
  }

  return (
    <CustomContent>
      <Row>
        <Col span={16}>
        </Col>
        <Col span={8}>
          <Row justify="end">
            <Space direction="horizontal">

              {hasWritePerm && (
                <Popconfirm
                  title={t('common.confirmation')}
                  description={t('common.areYouSureToDelete')}
                  icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                  onConfirm={onDelete}
                  okButtonProps={{ size: 'middle' }}
                  okText={t('common.yes')}
                  cancelButtonProps={{ size: 'middle' }}
                  styles={{ body: { padding: 16 } }}
                  disabled={selectedRowKeys.length === 0}
                >
                  <Button
                    disabled={selectedRowKeys.length === 0}
                    icon={<DeleteOutlined />}
                  >
                    {t('common.delete')}
                  </Button>
                </Popconfirm>
              )}
              {hasWritePerm && (
                <Button onClick={onAdd} icon={<PlusOutlined />} type="primary">
                  {t('common.add')}
                </Button>
              )}

            </Space>
          </Row>
        </Col>
      </Row>
      <Divider />
      <Table
        dataSource={data}
        columns={columns}
        loading={response.isFetching}
        rowKey={record => record.id}
        // onChange={handleTableChange}
        size='middle'
        // pagination={{
        //   pageSize: filters?.size,
        //   total: response.data ? response.data.data.totalElements : 0,
        //   showSizeChanger: true,
        //   current: filters ? filters.page + 1 : 1,
        //   pageSizeOptions: pageSizeOptions,
        //   showTotal: (total, range) => {
        //     return `${range[0]}-${range[1]} of ${total} items`;
        //   },
        // }}
        rowSelection={{
          selectedRowKeys,
          onChange: selected => setSelectedRowKeys(selected),
        }}
        onRow={record => {
          return {
            onClick: () => setSelectedItem(record),
          };
        }}
      />
    </CustomContent>
  );
};

export default ShowForms;

